// Base AWS Notification Endpoint
import axios from 'axios';

const host = window.location.hostname;
const isThHost = host.includes('.co.th');

const axiosConfig = {
  baseURL: isThHost
    ? 'https://gateway.bitazza.co.th/api/notification'
    : 'https://gateway.bitazzax.com/api/notification',
  timeout: 30000,
};

const BaseAxios = axios.create(axiosConfig);

export default BaseAxios;
